export enum ReferralStatusTypesEnum{
    Open = 1,
    ValidationFailed = 2,
    SubmissionFailed = 8,
    ReadyForSubmission = 9,
    Cancelled = 6
}